import React from 'react';
import ScrollReveal from '../../../components/ScrollReveal';

const ContactForm = () => {
  return (
    <section id="contact" className="section-py bg-dark-950 relative overflow-hidden">
      {/* Background effects - reduced on mobile for performance */}
      <div className="absolute inset-0 bg-dark-mesh" />
      <div className="hidden md:block absolute top-0 left-1/4 w-96 h-96 bg-primary-500 rounded-full blur-[200px] opacity-10" />
      <div className="hidden md:block absolute bottom-0 right-1/4 w-96 h-96 bg-accent-purple rounded-full blur-[200px] opacity-10" />

      <div className="container-lg relative">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left side - Content */}
          <ScrollReveal animation="fade-right">
            <div>
              <span className="label text-primary-400 mb-4 block">Get Started</span>
            <h2 className="heading-lg text-white mb-6">
              Ready to build
              <br />
              <span className="text-gradient">something great?</span>
            </h2>
            <p className="text-lg text-dark-400 leading-relaxed mb-8">
              Tell us about your project. We'll get back to you within 24 hours with a free consultation.
            </p>

            {/* Contact info */}
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-primary-500/10 rounded-xl flex items-center justify-center text-primary-400">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <div className="text-sm text-dark-500">Email us at</div>
                  <div className="text-white font-medium">lkelly@agalsoftwaresolutions.com</div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-primary-500/10 rounded-xl flex items-center justify-center text-primary-400">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <div className="text-sm text-dark-500">Response time</div>
                  <div className="text-white font-medium">Within 24 hours</div>
                </div>
              </div>
            </div>
            </div>
          </ScrollReveal>

          {/* Right side - Form */}
          <ScrollReveal animation="fade-left" delay={200}>
            <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary-500 via-accent-purple to-accent-cyan rounded-3xl blur opacity-20" />
            <div className="relative bg-dark-900 rounded-2xl p-5 sm:p-8 md:p-10 border border-dark-800">
              <form className="space-y-6">
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-dark-300 mb-2">
                      Your name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="w-full px-4 py-3.5 bg-dark-800 border border-dark-700 rounded-xl text-white placeholder-dark-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all"
                      placeholder="John Smith"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-dark-300 mb-2">
                      Work email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-3.5 bg-dark-800 border border-dark-700 rounded-xl text-white placeholder-dark-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all"
                      placeholder="john@company.com"
                      required
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="company" className="block text-sm font-medium text-dark-300 mb-2">
                      Company
                    </label>
                    <input
                      type="text"
                      id="company"
                      className="w-full px-4 py-3.5 bg-dark-800 border border-dark-700 rounded-xl text-white placeholder-dark-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all"
                      placeholder="Your Company"
                    />
                  </div>
                  <div>
                    <label htmlFor="budget" className="block text-sm font-medium text-dark-300 mb-2">
                      Budget range
                    </label>
                    <select
                      id="budget"
                      className="w-full px-4 py-3.5 bg-dark-800 border border-dark-700 rounded-xl text-white focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all appearance-none cursor-pointer"
                    >
                      <option value="">Select budget</option>
                      <option value="10-25k">$10k - $25k</option>
                      <option value="25-50k">$25k - $50k</option>
                      <option value="50-100k">$50k - $100k</option>
                      <option value="100k+">$100k+</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-dark-300 mb-2">
                    Tell us about your project
                  </label>
                  <textarea
                    id="message"
                    rows={4}
                    className="w-full px-4 py-3.5 bg-dark-800 border border-dark-700 rounded-xl text-white placeholder-dark-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-all resize-none"
                    placeholder="What are you looking to build? Any specific requirements or timeline?"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full btn btn-primary btn-lg group"
                >
                  <span className="relative z-10">Send Message</span>
                  <svg className="w-5 h-5 relative z-10 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>

                <p className="text-sm text-dark-500 text-center">
                  We respect your privacy. No spam, ever.
                </p>
              </form>
            </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
